jQuery( document ).ready(function() 
{
 wcAddClassToBodyBasedOnCurrentPage();
});

/*jQuery(window).scroll(function() {
    var sticky = jQuery('.sticky-add-to-cart'), scroll = jQuery(window).scrollTop();
  	if (scroll >= 100) sticky.addClass('fixed'); else sticky.removeClass('fixed');

});*/

function wcAddClassToBodyBasedOnCurrentPage()
{
	/** add class name to body  **/
	var url = window.location.href;
	if(url.indexOf('/pages/') >= 0)
	{
		var className = url.substr(url.indexOf('/pages/') + 7)
		if(className != null && className != undefined && className.length > 0) 
		{ 
			className = 'wc-'+className;
			if(!jQuery('body').hasClass(className))
			{
				jQuery('body').addClass(className);
			}
		}	
	}

	if(url.indexOf('/collections/') >= 0)
	{
		var className = url.substr(url.indexOf('/collections/') + 13)
		if(className != null && className != undefined && className.length > 0) 
		{ 
			className = 'wc-'+className;
			if(!jQuery('body').hasClass(className))
			{
				jQuery('body').addClass(className);
			}
		}	
	}

}